module.exports = __webpack_public_path__ + "media/reskin-images/icon--trash-ac71d936.svg";